import { render } from "./FormGroup.vue?vue&type=template&id=00176825"
import script from "./FormGroup.vue?vue&type=script&lang=js"
export * from "./FormGroup.vue?vue&type=script&lang=js"

import "./FormGroup.vue?vue&type=style&index=0&id=00176825&lang=postcss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__